
// Initialize Slick Slider for Awards Section (with fade animation)
$(document).ready(function () {
    //     const parentEl = document.querySelector('div[data-widget-host="habitat-static-feed"]');
    // const el = shadowRoot.shadowRoot.querySelector('a');
    // el.style.display = 'none';

    $('.awards-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0px',
        dots: true,
        arrows: true,
        infinite: true,
        // fade: true,  // This creates the opacity/show-hide effect
        // cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,  // Fade transition speed
        prevArrow: '<button type="button" class="slick-prev"><img src="//www.natpat.com/cdn/shop/files/lp-rewards-retail-arrow.svg?v=2038988765123612419" alt=""></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="//www.natpat.com/cdn/shop/files/lp-rewards-retail-arrow.svg?v=2038988765123612419" alt=""></button>',
    });
});

// Initialize Slick Slider for Industry Recognition
$(document).ready(function () {
    $('.industry-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        prevArrow: '<button type="button" class="slick-prev"><img src="//www.natpat.com/cdn/shop/files/lp-rewards-retail-arrow.svg?v=2038988765123612419" alt=""></button>',
        nextArrow: '<button type="button" class="slick-next"><img src="//www.natpat.com/cdn/shop/files/lp-rewards-retail-arrow.svg?v=2038988765123612419" alt=""></button>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});

$(document).ready(function() {
    const host = document.querySelector(
  'div[data-widget-host="habitat-static-feed"]'
);

console.log('host', host);

const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        const poll = setInterval(() => {
        if (!el.shadowRoot) return;

        clearInterval(poll);

        // 🔥 shadow root exists here
        el.shadowRoot.querySelector('a')?.remove();
        // or:
        // el.shadowRoot.querySelector('a')
        //   ?.style.setProperty('display', 'none', 'important');
        }, 100);
    });
    });

    observer.observe(host);
});